import React, { useState, useEffect } from "react";
import "./MyStyle/swagStyle.css";
import swal from "sweetalert";
import { SwagFooter } from "./SwagFooter";

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const MySwagCreator = () => {
  const [firstLoad, setfirstLoad] = useState(true);
  const [allcategoris, setAllCateories] = useState([]);
  const [allIndustryAff, setAllIndustryAff] = useState([]);
  const [showCategoryDD, setShowCategoryDD] = useState(false);
  const [showOtherCategoryDD, setShowOtherCategoryDD] = useState(false);
  const [showIndustryAff, setShowIndustryAff] = useState(false);
  const [showOtherIndustryAff, setShowOtherIndustryAff] = useState(false);
  const [ytSelectOpen, setYtSelectOpen] = useState(false);
  const [igSelectOpen, setIgSelectOpen] = useState(false);
  const [fbSelectOpen, setFbSelectOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [step, setStep] = useState(1);
  const [allSocialFollowers, setAllSocialFollowers] = useState();
  const [submitAllDetails, setSubmitAllDetails] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    mobileNo: "",
    emailAdd: "",
    categories: "",
    otherCategory: "",
    workSamples: "",
    otherLinks: "",
    productionHouse: "",
    industryAff: "",
    otherIndustryAff: "",
    youtube: { URL: "", followers: 0 },
    instagram: { URL: "", followers: 0 },
    facebook: { URL: "", followers: 0 },
  });

  const toggleDropdown = (e) => {
    const dropdownButton = document.getElementById("ddlCategories");
    const dropdownMenu = document.getElementById("customDropdownMenu");
    const dropdownIndustry = document.getElementById("ddlIndustryAffiliations");
    const dropdownButton2 = document.getElementById("customDropdownButton2");
    const dropdownButton3 = document.getElementById("customDropdownButton3");
    const dropdownButton4 = document.getElementById("customDropdownButton4");

    if (
      dropdownMenu &&
      dropdownButton &&
      !dropdownMenu.contains(e.target) &&
      e.target !== dropdownButton
    ) {
      setShowCategoryDD(false);
    }
    if (dropdownIndustry && e.target !== dropdownIndustry) {
      setShowIndustryAff(false);
    }
    //closing social DD
    if (dropdownButton2 && e.target !== dropdownButton2) {
      setYtSelectOpen((prv) => (prv ? !prv : prv));
    }
    if (dropdownButton3 && e.target !== dropdownButton3) {
      setIgSelectOpen((prv) => (prv ? !prv : prv));
    }
    if (dropdownButton4 && e.target !== dropdownButton4) {
      setFbSelectOpen((prv) => (prv ? !prv : prv));
    }
  };

  const updateFormData = (key, e) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: e.target.value,
    }));
  };

  const updateSocialFormURLData = (social, key, e) => {
    setFormData((prevState) => ({
      ...prevState,
      [social]: { ...prevState[social], [key]: e.target.value },
    }));
  };

  const handleClickFollower = (social) => {
    if (social === "youtube") {
      setYtSelectOpen((prv) => !prv);
    } else if (social === "instagram") {
      setIgSelectOpen((prv) => !prv);
    } else {
      setFbSelectOpen((prv) => !prv);
    }
  };

  const handleFollowerChange = (social, e) => {
    setFormData((prevState) => ({
      ...prevState,
      [social]: { ...prevState[social], followers: parseInt(e.target.value) },
    }));
  };

  const ddlCategoryHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowCategoryDD((prv) => !prv);
  };

  const updateSelectedCategories = (event) => {
    const { value, checked } = event.target;
    let finalCategories = [];

    if (value === "Other" && checked) {
      setShowOtherCategoryDD(true);
    } else if (value === "Other" && !checked) {
      setFormData((prevState) => ({
        ...prevState,
        otherCategory: "",
      }));
      setShowOtherCategoryDD(false);
    }

    if (checked) {
      finalCategories = [...selectedCategories, value];
      setSelectedCategories(finalCategories);
    } else {
      finalCategories = selectedCategories.filter(
        (category) => category !== value,
      );
      setSelectedCategories(finalCategories);
    }

    const selectedCategoriesString = finalCategories.join(", ");
    setFormData((prv) => ({ ...prv, categories: selectedCategoriesString }));
  };

  const saveNextform1 = (e) => {
    e.preventDefault();
    if (validateform1()) {
      setStep(2);
      getIndustryAff();
      updateStepIndicator(1);
    }
  };

  const saveNextform2 = () => {
    if (validateform2()) {
      setStep(3);
      getAllSocialFollowers();
      updateStepIndicator(2);
    }
  };

  const validateform1 = () => {
    const name = formData.name;
    const mobileCheck = validateMobile(formData.mobileNo);

    var emailRegex =
      /^[^@\s]+@[^@\s]+\.(com|net|org|gov|in|co|COM|Com|NET|Net|ORG|Org|GOV|Gov|IN|In|CO|Co)$/;
    var emailCheck = emailRegex.test(formData.emailAdd);
    if (name === null || name === "") {
      showtoast("error", "Name is required.");
      document
        .getElementById("txtName")
        .style.setProperty("border-color", "red", "important");
      document.getElementById("txtName").focus();
      return false;
    } else {
      document
        .getElementById("txtName")
        .style.setProperty("border-color", "#ced4da", "important");
    }

    if (formData.mobileNo === null || formData.mobileNo === "") {
      showtoast("error", "Enter a mobile number.");
      document
        .getElementById("txtMobileNo")
        .style.setProperty("border-color", "red", "important");
      document.getElementById("txtMobileNo").focus();
      return false;
    } else {
      document
        .getElementById("txtMobileNo")
        .style.setProperty("border-color", "#ced4da", "important");
    }

    if (!mobileCheck) {
      showtoast("error", "Enter a valid mobile number.");
      document
        .getElementById("txtMobileNo")
        .style.setProperty("border-color", "red", "important");
      document.getElementById("txtMobileNo").focus();
      return false;
    } else {
      document
        .getElementById("txtMobileNo")
        .style.setProperty("border-color", "#ced4da", "important");
    }

    if (
      formData.emailAdd === null ||
      formData.emailAdd === "" ||
      formData.emailAdd === ""
    ) {
      showtoast("error", "Please enter the email Id.");
      document
        .getElementById("txtEmailId")
        .style.setProperty("border-color", "red", "important");
      document.getElementById("txtEmailId").focus();
      return false;
    } else {
      document
        .getElementById("txtEmailId")
        .style.setProperty("border-color", "#ced4da", "important");
    }
    if (!emailCheck) {
      showtoast("error", "Enter a valid Email ID.");
      document
        .getElementById("txtEmailId")
        .style.setProperty("border-color", "red", "important");
      document.getElementById("txtEmailId").focus();
      return false;
    } else {
      document
        .getElementById("txtEmailId")
        .style.setProperty("border-color", "#ced4da", "important");
    }

    if (formData.categories == null || formData.categories === "") {
      showtoast("error", "Category name is required.");
      document
        .getElementById("ddlCategories")
        .style.setProperty("border-color", "red", "important");
      document.getElementById("ddlCategories").focus();
      return false;
    } else {
      document
        .getElementById("ddlCategories")
        .style.setProperty("border-color", "#ced4da", "important");
    }
    if (formData.categories.includes("Other")) {
      if (formData.otherCategory == null || formData.otherCategory === "") {
        showtoast("error", "Other Category name is required.");
        document
          .getElementById("txtOtherCategory")
          .style.setProperty("border-color", "red", "important");
        document.getElementById("txtOtherCategory").focus();
        return false;
      } else {
        document
          .getElementById("txtOtherCategory")
          .style.setProperty("border-color", "#ced4da", "important");
      }
    }

    return true;
  };

  const validateMobile = (mobile) => {
    const mobileRegex = new RegExp("^[6-9]\\d{9}$");
    return mobileRegex.test(mobile);
  };

  const validateform2 = () => {
    var workSamples = formData.workSamples;
    var worksampleRegex =
      /^(https?:\/\/)?([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/\S*)?$/;
    var workSample = worksampleRegex.test(workSamples);

    if (workSamples == null || workSamples === "") {
      showtoast("error", "Work samples are required.");

      document
        .getElementById("txtWorkSamples")
        .style.setProperty("border-color", "red", "important");
      document.getElementById("txtWorkSamples").focus();
      return false;
    } else {
      document
        .getElementById("txtWorkSamples")
        .style.setProperty("border-color", "#ced4da", "important");
    }
    if (!workSample) {
      showtoast("error", "Enter a valid Work Sample URL.");
      document
        .getElementById("txtWorkSamples")
        .style.setProperty("border-color", "red", "important");
      document.getElementById("txtWorkSamples").focus();
      return false;
    } else {
      document
        .getElementById("txtWorkSamples")
        .style.setProperty("border-color", "#ced4da", "important");
    }

    return true;
  };

  const toggleDropdownIndustry = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowIndustryAff((prv) => !prv);
  };

  const selectIndustryAffiliation = (selectedValue, b) => {
    setFormData((prv) => ({ ...prv, industryAff: selectedValue }));
    toggleDropdown(b);

    // If "Others" is selected, show the additional input for specifying the other industry
    if (selectedValue === "Others") {
      setShowOtherIndustryAff(true);
    } else {
      setFormData((prevState) => ({
        ...prevState,
        otherIndustryAff: "",
      }));
      setShowOtherIndustryAff(false);
    }
  };

  const restrictToAlphabetic = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^a-zA-Z\s]/g, "");
  };

  const checkMaxLength = (e) => {
    const maxLength = 10;
    const input = e.target;

    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
    }
  };

  const OnlyNumeric = (e) => {
    let value = e.target.value;
    let numbers = value.replace(/[^0-9]/g, "");
    e.target.value = numbers;
    checkMaxLength(e);
  };

  const getAllSocialFollowers = () => {
    fetch(`${apiBaseURL}/api/WebAncillary/GetAllFollowers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((res) => {
        setAllSocialFollowers(res);
      })
      .catch((err) => {
        console.error("Error calling API:", err);
      });
  };

  const getIndustryAff = () => {
    fetch(`${apiBaseURL}/api/WebAncillary/GetIndustry`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((res) => {
        setAllIndustryAff(res);
      })
      .catch((err) => {
        console.error("Error calling API:", err);
      });
  };

  function updateStepIndicator(stepIndex) {
    const stepSpans = document.querySelectorAll("#personal");
    const icons = document.querySelectorAll(
      ".info-item .toggle-icon .my-check-tick",
    );
    const arrows = document.querySelectorAll(".info-item i.fas.fa-angle-right");

    icons.forEach((icon, index) => {
      const arrow = arrows[index];

      // If the current index is less than the current step (stepIndex)
      if (index < stepIndex) {
        icon.classList.add("green-color");
        stepSpans[index].classList.remove("color-info-act"); // Ensure stepSpan isn't active
        icon.classList.remove("active-icon"); // Remove the active state
        icon.innerHTML = '<i className="fas fa-check"></i>'; // Show checkmark
        arrow.style.color = "green"; // Set arrow color to green
      }
      // If it's the current step
      else if (index === stepIndex) {
        icon.classList.add("active-icon"); // Make it active
        stepSpans[index].classList.add("color-info-act"); // Highlight current step
        icon.classList.remove("green-color"); // Remove green color
        icon.innerHTML = (index + 1).toString(); // Display step number
      }
      // If it's greater than the current step
      else {
        icon.classList.remove("active-icon"); // Remove active state
        stepSpans[index].classList.remove("color-info-act"); // Remove highlight
        icon.innerHTML = (index + 1).toString(); // Display step number
      }
    });
  }

  const onFinalSubmit = () => {
    var model = {
      Id: 1,
      Name: formData.name,
      EmailId: formData.emailAdd,
      MobileNumber: formData.mobileNo,
      CategoryName: formData.categories,
      OtherCategory: formData.otherCategory,
      WorkSamples: formData.workSamples,
      OtherLink: formData.otherLinks,
      NameoftheProductionHouse: formData.productionHouse,
      IndustryAffiliationsName: formData.industryAff,
      OtherIndustryAffiliation: formData.otherIndustryAff,
      YoutubeProfile: formData.youtube.URL,
      YFID: formData.youtube.followers,
      InstagramProfile: formData.instagram.URL,
      IFID: formData.instagram.followers,
      FacebookProfile: formData.facebook.URL,
      FFID: formData.facebook.followers,
    };

    fetch(`${apiBaseURL}/api/WebAncillary/SubmitSwagDetails`, {
      method: "POST",
      body: JSON.stringify(model),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((res) => {
        setSubmitAllDetails(res);
        onSuccessSubmitSwag(res);
      })
      .catch((err) => {
        console.error("Error submitting:", err);
        showtoast("error", "Something went wrong, please try after sometime");
      });
  };

  const onSuccessSubmitSwag = (data) => {
    if (data.resultCode === 0) {
      ClearInputData();

      swal({
        title: "Done",
        text: data.resultDesc,
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "",
            closeModal: true,
          },
        },
      }).then(() => {
        window.location.reload();
      });

      window.scrollTo(0, 2);
    } else if (data.resultCode !== 0) {
      window.scrollTo(0, 2);

      swal({
        title: "",
        text: data.resultDesc,
        icon: "error",
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "",
            closeModal: true,
          },
        },
      });
    }
  };

  const ClearInputData = () => {
    setFormData({
      name: "",
      mobileNo: "",
      emailAdd: "",
      categories: "",
      otherCategory: "",
      workSamples: "",
      otherLinks: "",
      productionHouse: "",
      industryAff: "",
      otherIndustryAff: "",
      youtube: { URL: "", followers: "" },
      instagram: { URL: "", followers: "" },
      facebook: { URL: "", followers: "" },
    });
  };

  const showtoast = (type, message) => {
    let toastElement = document.createElement("div");
    toastElement.innerText = message;
    if (type === "error") {
      toastElement.classList.add("toast-error");
    }
    toastElement.classList.add("toast-message");
    document.body.appendChild(toastElement);

    setTimeout(function () {
      toastElement.classList.add("fade-out");

      setTimeout(function () {
        document.body.removeChild(toastElement);
      }, 500);
    }, 3000);
  };

  const handlePrvStep = (e, i) => {
    e.preventDefault();
    setStep(i);
    updateStepIndicator(i - 1);
  };

  useEffect(() => {
    document.title = "Become Swag Creator";
    const getAllCategories = () => {
      fetch(`${apiBaseURL}/api/WebAncillary/GetCategories`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((res) => {
          setAllCateories(res);
        })
        .catch((err) => {
          console.error("Error calling API:", err);
        });
    };

    if (firstLoad) {
      getAllCategories();
      updateStepIndicator(0);
      setfirstLoad(false);
    }
  }, [step, formData, firstLoad]);

  return (
    <div onClick={toggleDropdown} className="swagMain">
      <div className="container my-5">
        <div className="exp-div">
          <div className="row shadowed-row">
            <div className="col-lg-5 col-md-12 mb-lg-0 p-0">
              <img
                className="img-fluid image-class-meri"
                src="/Images/SwagCreator/SWAG PAGE BANNER-0175.jpg"
                style={{ height: "100%" }}
                alt="banner"
              />
            </div>
            <div className="col-lg-7 col-md-12 p-0">
              <div className="step-form-part1">
                <div className="info-container">
                  <div className="info-categories">
                    <div className="info-item">
                      <div className="toggle-icon">
                        <span className="my-check-tick active-icon ">1</span>
                      </div>
                      <span id="personal">Personal Info</span>
                    </div>
                    <div className="info-item">
                      <i className="fas fa-angle-right arr-colur"></i>
                    </div>
                    <div className="info-item">
                      <div className="toggle-icon">
                        <span className="my-check-tick ">2</span>
                      </div>
                      <span id="personal">Professional Info</span>
                    </div>
                    <div className="info-item">
                      <i className="fas fa-angle-right arr-colur"></i>
                    </div>
                    <div className="info-item">
                      <div className="toggle-icon">
                        <span className="my-check-tick ">3</span>
                      </div>
                      <span id="personal">Social Network</span>
                    </div>
                  </div>
                </div>
                <div className="step-form">
                  {step === 1 && (
                    <div className="step-content">
                      <h2 className="step-title">Personal Information</h2>
                      <div className="containerSwag my-4">
                        <div className="row">
                          <div className="col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="Name">
                                Name <span className="star-col">*</span>
                              </label>
                              <input
                                asp-for="Name"
                                type="text"
                                value={formData.name}
                                onChange={(e) => updateFormData("name", e)}
                                id="txtName"
                                required
                                placeholder="Enter your full name"
                                onInput={restrictToAlphabetic}
                                maxLength="30"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                            <span
                              asp-validation-for="Name"
                              className="text-danger error-span"
                            ></span>
                          </div>

                          <div className="col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="MobileNumber">
                                Mobile Number{" "}
                                <span className="star-col">*</span>
                              </label>
                              <input
                                asp-for="MobileNumber"
                                value={formData.mobileNo}
                                onChange={(e) => updateFormData("mobileNo", e)}
                                type="text"
                                id="txtMobileNo"
                                onInput={OnlyNumeric}
                                maxLength="10"
                                required
                                placeholder="10 digit number"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                            <span
                              asp-validation-for="MobileNumber"
                              className="error-span text-danger"
                            ></span>
                          </div>
                          <div className=" col-md-6 mb-3 p-0">
                            <div className="form-group ">
                              <label asp-for="EmailId">
                                Email Address{" "}
                                <span className="star-col">*</span>
                              </label>
                              <input
                                asp-for="EmailId"
                                value={formData.emailAdd}
                                onChange={(e) => updateFormData("emailAdd", e)}
                                type="email"
                                id="txtEmailId"
                                maxLength="30"
                                required
                                placeholder="Email Address"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                            <span
                              asp-validation-for="EmailId"
                              className="error-span text-danger"
                            ></span>
                          </div>
                          <div className="col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="Category">
                                Choose Categories{" "}
                                <span className="star-col">*</span>
                              </label>

                              <div className="custom-dropdown-wrapper">
                                <input
                                  type="text"
                                  value={formData.categories || ""}
                                  id="ddlCategories"
                                  className="form-control input-lt"
                                  readOnly
                                  placeholder="Select"
                                  style={{ paddingRight: "30px" }}
                                  onClick={ddlCategoryHandler}
                                />
                                <i
                                  className={`fa drpdn-icn${
                                    showCategoryDD
                                      ? " fa-angle-up"
                                      : " fa-angle-down"
                                  }`}
                                  id="customDropdownButtonarrow"
                                ></i>
                              </div>
                              {showCategoryDD && (
                                <div
                                  id="customDropdownMenu"
                                  className="custom-dropdown-menu show"
                                >
                                  {allcategoris &&
                                    allcategoris.length > 0 &&
                                    allcategoris.map((item, idx) => (
                                      <label
                                        className="dropdown-item"
                                        key={idx}
                                      >
                                        <input
                                          type="checkbox"
                                          id={`customCheckbox_${item.categoryName}`}
                                          value={item.categoryName}
                                          checked={selectedCategories.includes(
                                            item.categoryName,
                                          )}
                                          className="category-checkbox input-lt"
                                          onChange={updateSelectedCategories}
                                        />
                                        <span className="movie-color">
                                          {item.categoryName}
                                        </span>
                                      </label>
                                    ))}
                                </div>
                              )}
                            </div>
                            <span
                              asp-validation-for="Category"
                              className="error-span text-danger"
                            ></span>
                          </div>

                          {showOtherCategoryDD && (
                            <div
                              className=" col-md-12 mb-3 p-0"
                              id="othercategory"
                            >
                              <div className="form-group">
                                <label asp-for="OtherCategory">
                                  Other Category{" "}
                                  <span className="star-col">*</span>
                                </label>
                                <input
                                  type="text"
                                  value={formData.otherCategory}
                                  onChange={(e) =>
                                    updateFormData("otherCategory", e)
                                  }
                                  className="form-control input-lt"
                                  id="txtOtherCategory"
                                  placeholder="Enter Other Category"
                                  maxLength="30"
                                />
                              </div>
                            </div>
                          )}
                          <div
                            className="Mandatory-topmargin"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              fontWeight: "bold",
                              width: "90%",
                            }}
                          >
                            <span style={{ color: "red", textAlign: "center" }}>
                              * All Fields are Mandatory
                            </span>
                          </div>
                          <div className="buttn-section1">
                            <button
                              type="button"
                              id="btnSubmit2"
                              className=" next-step"
                              onClick={saveNextform1}
                            >
                              Save & Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {step === 2 && (
                    <div className="step-content">
                      <h2 className="step-title">Professional Information</h2>
                      <div className="containerSwag my-4">
                        <div className="row">
                          <div className=" col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="WorkSamples">
                                Work Samples <span className="star-col">*</span>
                              </label>
                              <input
                                asp-for="WorkSamples"
                                value={formData.workSamples}
                                onChange={(e) =>
                                  updateFormData("workSamples", e)
                                }
                                type="text"
                                id="txtWorkSamples"
                                required
                                maxLength="50"
                                placeholder="e.g.https://www.youtube.com/watch?v"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                            <span
                              asp-validation-for="WorkSamples"
                              className="error-span text-danger"
                            ></span>
                          </div>
                          <div className=" col-md-6 mb-3 p-0">
                            <div className="form-group ">
                              <label asp-for="OtherLink">Other Link</label>
                              <input
                                asp-for="OtherLink"
                                type="text"
                                value={formData.otherLinks}
                                onChange={(e) =>
                                  updateFormData("otherLinks", e)
                                }
                                id="txtOtherLink"
                                required
                                maxLength="50"
                                placeholder="e.g.https://vimeo.com/123"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                            <span
                              asp-validation-for="OtherLink"
                              className="error-span text-danger"
                            ></span>
                          </div>
                          <div className=" col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="NameoftheProductionHouse">
                                Name of the Production House{" "}
                              </label>
                              <input
                                asp-for="NameoftheProductionHouse"
                                type="text"
                                value={formData.productionHouse}
                                onChange={(e) =>
                                  updateFormData("productionHouse", e)
                                }
                                id="txtNameoftheProductionHouse"
                                required
                                maxLength="25"
                                placeholder="Production house name"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                            <span
                              asp-validation-for="NameoftheProductionHouse"
                              className="error-span text-danger"
                            ></span>
                          </div>

                          <div className="col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="IndustryAffiliations">
                                Industry Affiliations{" "}
                              </label>

                              <div
                                className="custom-dropdown-wrapper"
                                onClick={toggleDropdownIndustry}
                              >
                                <input
                                  type="text"
                                  value={formData.industryAff}
                                  id="ddlIndustryAffiliations"
                                  className="form-control input-lt"
                                  readOnly
                                  placeholder="Select"
                                  style={{ paddingRight: "30px" }}
                                />
                                <i
                                  className={`fa drpdn-icn${
                                    showIndustryAff
                                      ? " fa-angle-up"
                                      : " fa-angle-down"
                                  }`}
                                  id="customDropdownButtonarrowIndustry"
                                ></i>
                              </div>
                              {showIndustryAff && (
                                <div
                                  id="customDropdownMenuIndustry"
                                  className="custom-dropdown-menui"
                                  style={{ display: "block" }}
                                >
                                  {allIndustryAff &&
                                    allIndustryAff.length > 0 &&
                                    allIndustryAff.map((item, idx) => (
                                      <label
                                        className="dropdown-itemi"
                                        key={idx}
                                      >
                                        <div
                                          className="dropdown-itemi hover-on-dropdown-itemi"
                                          onClick={(e) =>
                                            selectIndustryAffiliation(
                                              `${item.industryAffiliationsName}`,
                                              e,
                                            )
                                          }
                                        >
                                          {item.industryAffiliationsName}
                                        </div>
                                      </label>
                                    ))}
                                  <div
                                    className="dropdown-itemi hover-on-dropdown-itemi"
                                    onClick={(e) =>
                                      selectIndustryAffiliation("Others", e)
                                    }
                                  >
                                    Others
                                  </div>
                                </div>
                              )}
                            </div>
                            <span
                              asp-validation-for="IndustryAffiliations"
                              className="error-span text-danger"
                            ></span>
                          </div>
                          {showOtherIndustryAff && (
                            <div
                              className="col-md-12 mb-3 p-0"
                              id="otheraffiliation1"
                            >
                              <div className="form-group">
                                <label asp-for="OtherIndustryAffiliation">
                                  Other Industry Affiliation{" "}
                                </label>
                                <input
                                  type="text"
                                  value={formData.otherIndustryAff}
                                  onChange={(e) =>
                                    updateFormData("otherIndustryAff", e)
                                  }
                                  className="form-control input-lt"
                                  id="txtOtherIndustryAffiliation"
                                  maxLength="50"
                                  placeholder="Enter Other Industry Affiliation"
                                />
                              </div>
                            </div>
                          )}
                          <div
                            className="Mandatory-topmargini"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              fontWeight: "bold",
                              width: "90%",
                            }}
                          >
                            <span style={{ color: "red", textAlign: "center" }}>
                              * All Fields are Mandatory
                            </span>
                          </div>
                          <div className="buttn-section1">
                            <button
                              type="button"
                              id="PrevButton"
                              className=" prev-step"
                              onClick={(e) => handlePrvStep(e, 1)}
                            >
                              Previous
                            </button>
                            <button
                              type="button"
                              id="btnSubmit3"
                              className=" next-step"
                              onClick={saveNextform2}
                            >
                              Save & Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {step === 3 && (
                    <div className="step-content">
                      <h2 className="step-title">Social Network</h2>
                      <div className="containerSwag my-4">
                        <div className="row">
                          <div className=" col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="YoutubeProfile">
                                Youtube Profile
                              </label>
                              <input
                                asp-for="YoutubeProfile"
                                value={formData.youtube.URL}
                                onChange={(e) =>
                                  updateSocialFormURLData("youtube", "URL", e)
                                }
                                type="text"
                                id="txtYoutubeProfile"
                                required
                                maxLength="50"
                                placeholder="Enter Profile URL"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                          </div>

                          <div className="col-md-6 mb-3 p-0 socialDDSelect">
                            <div className="form-group">
                              <label asp-for="YoutubeFollowers">
                                Youtube Followers
                              </label>
                              <select
                                value={formData.youtube.followers}
                                onChange={(e) =>
                                  handleFollowerChange("youtube", e)
                                }
                                onClick={() => handleClickFollower("youtube")}
                                className="form-control"
                                style={{ paddingRight: "30px" }}
                                id="customDropdownButton2"
                              >
                                <option value="">Select</option>
                                {allSocialFollowers &&
                                  allSocialFollowers.length > 0 &&
                                  allSocialFollowers.map((follower) => (
                                    <option
                                      key={follower.yfid}
                                      value={follower.yfid}
                                    >
                                      {follower.yfName}
                                    </option>
                                  ))}
                              </select>
                              <i
                                className={`fa drpdn-icn${
                                  ytSelectOpen
                                    ? " fa-angle-up"
                                    : " fa-angle-down"
                                }`}
                                id="customDropdownButtonarrowyoutube"
                              ></i>
                            </div>
                          </div>
                          <div className=" col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="InstagramProfile">
                                Instagram Profile
                              </label>
                              <input
                                asp-for="InstagramProfile"
                                value={formData.instagram.URL}
                                onChange={(e) =>
                                  updateSocialFormURLData("instagram", "URL", e)
                                }
                                type="text"
                                id="txtInstagramProfile"
                                required
                                maxLength="25"
                                placeholder="Enter Profile URL"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                          </div>

                          <div className="col-md-6 mb-3 p-0 socialDDSelect">
                            <div className="form-group">
                              <label asp-for="InstagramFollowers">
                                Instagram Followers
                              </label>
                              <select
                                value={formData.instagram.followers}
                                onChange={(e) =>
                                  handleFollowerChange("instagram", e)
                                }
                                onClick={() => handleClickFollower("instagram")}
                                className="form-control"
                                style={{ paddingRight: "30px" }}
                                id="customDropdownButton3"
                              >
                                <option value="">Select</option>
                                {allSocialFollowers &&
                                  allSocialFollowers.length > 0 &&
                                  allSocialFollowers.map((follower) => (
                                    <option
                                      key={follower.ifid}
                                      value={follower.ifid}
                                    >
                                      {follower.ifName}
                                    </option>
                                  ))}
                              </select>
                              <i
                                className={`fa drpdn-icn${
                                  igSelectOpen
                                    ? " fa-angle-up"
                                    : " fa-angle-down"
                                }`}
                                id="customDropdownButtonarrowinsta"
                              ></i>
                            </div>
                          </div>
                          <div className=" col-md-6 mb-3 p-0">
                            <div className="form-group">
                              <label asp-for="FacebookProfile">
                                Facebook Profile
                              </label>
                              <input
                                asp-for="FacebookProfile"
                                type="text"
                                value={formData.facebook.URL}
                                onChange={(e) =>
                                  updateSocialFormURLData("facebook", "URL", e)
                                }
                                id="txtFacebookProfile"
                                required
                                maxLength="25"
                                placeholder="Enter Profile URL"
                                className="form-control input-lt"
                                autoComplete="off"
                              />
                            </div>
                          </div>
                          <div className="col-md-6 mb-3 p-0 socialDDSelect">
                            <div className="form-group">
                              <label asp-for="FacebookFollowers">
                                Facebook Followers
                              </label>
                              <i
                                className={`fa drpdn-icn${
                                  fbSelectOpen
                                    ? " fa-angle-up"
                                    : " fa-angle-down"
                                }`}
                                id="customDropdownButtonarrowfacebook"
                              ></i>
                              <select
                                value={formData.facebook.followers}
                                onChange={(e) =>
                                  handleFollowerChange("facebook", e)
                                }
                                onClick={() => handleClickFollower("facebook")}
                                className="form-control"
                                style={{ paddingRight: "30px" }}
                                id="customDropdownButton4"
                              >
                                <option value="">Select</option>
                                {allSocialFollowers &&
                                  allSocialFollowers.length > 0 &&
                                  allSocialFollowers.map((follower) => (
                                    <option
                                      key={follower.ffid}
                                      value={follower.ffid}
                                    >
                                      {follower.ffName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                          <div className="buttn-section-diff">
                            <button
                              type="button"
                              className=" prev-step"
                              onClick={(e) => handlePrvStep(e, 2)}
                            >
                              Previous
                            </button>
                            <button
                              type="submit"
                              className="next-step-new"
                              id="btnsubmit1"
                              data-toggle="modal"
                              onClick={onFinalSubmit}
                            >
                              Submit
                            </button>
                            <div
                              className="modal fade"
                              id="myModal"
                              role="dialog"
                            >
                              <div className="modal-dialog">
                                <div className="modal-content-center">
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                  >
                                    <img
                                      src="/Images/SwagCreator/x.png"
                                      alt="swg2"
                                    />
                                  </button>
                                  <div className="congrats-container">
                                    <div className="check-icon">
                                      <img
                                        src="/Images/SwagCreator/Group 39.png"
                                        alt="swg"
                                      />
                                    </div>
                                    <h2>Successfully Completed!</h2>
                                    <p className="submitted-successfully">
                                      Your information has been submitted
                                      successfully
                                    </p>
                                    <p className="submitted-successfully">
                                      Our team will reach out to you soon
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="modal fade"
                              id="myModal1"
                              role="dialog"
                            >
                              <div className="modal-dialog">
                                <div className="modal-content-center">
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                  >
                                    &times;
                                  </button>
                                  <div className="congrats-container">
                                    <div className="check-icon-my-check">
                                      <i
                                        className="fa fa-close"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                    <h2 className=" my-error">Error</h2>
                                    <p className="submitted-successfully">
                                      There was an error submitting your
                                      information. Please try again.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="footer-normal">
                        <p className="footer-line">
                          By proceeding you confirm that you are of 18 year or{" "}
                          <br /> above and accept the{" "}
                          <a
                            href="https://www.vzy.one/en/supportPage/termsOfUse"
                            target="_blank"
                          >
                            Terms of Use
                          </a>{" "}
                          &{" "}
                          <a
                            href="https://www.vzy.one/en/supportPage/privacyPolicy"
                            target="_blank"
                          >
                            Privacy Policy
                          </a>
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SwagFooter />
    </div>
  );
};
